<template lang="pug">
b-modal#addGameNameExclude(
  ref="addGameNameExclude"
  :title="$t('ui.combine.add_game_exclude')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.provider')").mb-0
      template(v-if="isOperator")
        ProviderLookup(
          size="sm"
          required
          type="array"
          ref="provider_code"
          :operatorID="operatorID"
          :isDisabled="true"
          :dirty="$v.provider_code.$dirty"
          :error="$v.provider_code.$error"
          v-model.trim.lazy="$v.provider_code.$model"
          :disabled="loading"
        )
      template(v-else)
        ProviderGlobalLookup(
          size="sm"
          required
          type="array"
          ref="provider_code"
          :isDisabled="true"
          :dirty="$v.provider_code.$dirty"
          :error="$v.provider_code.$error"
          v-model.trim.lazy="$v.provider_code.$model"
          :disabled="loading"
        )
      ValidateResult(:value="$v.provider_code" :name="$t('ui.provider')")
    b-form-group(:label="$t('ui.game_name')").mb-0
      DebounceInput(
        size="sm"
        required
        type="text"
        ref="game_name"
        :dirty="$v.game_name.$dirty"
        :error="$v.game_name.$error"
        v-model.trim.lazy="$v.game_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.game_name" :name="$t('ui.game_name')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, helpers, ipAddress } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import ProviderLookup from "@/library/ProviderLookup.vue";
import ProviderGlobalLookup from "@/library/ProviderGlobalLookup.vue";

export default {
components: {
  SubmitButton,
  ValidateResult,
  DebounceInput,
  ProviderLookup,
  ProviderGlobalLookup
},
data() {
  return {
    provider_code: "",
    game_name: "",
    loading: false,
    feedback: {
      success: true,
      status: ""
    }
  };
},
computed: {
  operatorID() {
    return this.$store.getters.selectedOperatorID;
  },
  isOperator() {
    return [2].includes(this.$store.getters.accountType);
  }
},
validations: {
  provider_code: {
    required
  },
  game_name: {
    required,
    minLength: minLength(2),
    maxLength: maxLength(100),
  }
},
methods: {
  done: function(evt) {
    evt.preventDefault();
    this.submit();
  },
  submit: function() {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      let url = config.gameNameExcludeAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: this.provider_code,
        game_name: this.game_name,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addGameNameExclude.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_game_exclude", this.feedback.status);
                this.$refs.addGameNameExclude.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    }
  },
  reset: function() {
    this.feedback.success = true;
    this.feedback.status = "";
  },
  shown: function() {
    this.$v.$reset();
    this.provider_code = "";
    this.game_name = "";
    this.$refs.provider_code.$el.focus();
  }
}
};
</script>
